import * as Highcharts from 'highcharts';

export const hideTooltipDescriptionForMobileChartOptions: Highcharts.Options = {
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 575,
        },
        chartOptions: {
          tooltip: {
            pointFormat: '<span style="color:{series.color}">\u25CF</span><b> {point.y}</b><br/>',
            split: true,
          },
        },
      },
    ],
  },
};
